jQuery(document).ready(function ($) {
    $('.faq-item summary').on('click', function (e) {
        e.preventDefault();

        const $summary = $(this);
        const $item = $summary.parent(); // The `details` element
        const $plusIcon = $summary.find('.plus-icon');
        const $minusIcon = $summary.find('.minus-icon');

        if ($item.attr('open')) {
            $item.removeAttr('open');
            $plusIcon.removeClass('close-icon').addClass('open-icon');
            $minusIcon.removeClass('open-icon').addClass('close-icon');
        } else {
            $item.attr('open', true);
            $plusIcon.removeClass('open-icon').addClass('close-icon');
            $minusIcon.removeClass('close-icon').addClass('open-icon');

            $('.faq-item[open]').not($item).each(function () {
                const $otherPlusIcon = $(this).find('.plus-icon');
                const $otherMinusIcon = $(this).find('.minus-icon');

                $(this).removeAttr('open');
                $otherPlusIcon.removeClass('close-icon').addClass('open-icon');
                $otherMinusIcon.removeClass('open-icon').addClass('close-icon');
            });
        }
    });
}); 
